<ion-content class="ion-padding">
  <div class="confirm-wrapper">
    <h4>
      Congratulations, your listing<span *ngIf="sites?.length > 1">s are</span>
      <span *ngIf="sites?.length <= 1"> is</span> complete!
    </h4>
    <p class="lead">
      Now that you are 100% complete you can publish
      <span *ngIf="sites?.length <= 1">it</span>
      <span *ngIf="sites?.length > 1">them</span> to the CurbNTurf website and start making money!
    </p>

    <h5 *ngIf="sites?.length === 1">The listing ready is {{ sites[0].name }}</h5>

    <div *ngIf="sites?.length > 1">
      <h5>These listings are ready:</h5>
      <h5 *ngFor="let site of sites">{{ site.name }}</h5>
    </div>

    <div class="button-wrapper">
      <button (click)="publishFunction()" type="button" class="cnt-button publish-button">
        <div class="cnt-button-copy">Publish listing<span *ngIf="sites?.length > 1">s</span></div>
      </button>
      <button (click)="hideFunction()" type="button" class="cnt-button text-capitalize">
        <div class="cnt-button-copy">Wait to publish another time.</div>
      </button>
    </div>
  </div>
</ion-content>
